import React, { useState, useEffect } from 'react';
import img from '../../assests/images/Images';

/**
 * WhatsApp floating action button positioned at the bottom right.
 * Layout, positioning, and spacing handled by Bootstrap 5.
 * Colors and visual micro-utilities handled by Tailwind CSS.
 * Smooth entrance transition on page load + continuous ambient ripple & glow animations.
 */
const WhatsAppButton = ({
  phoneNumber = '919751836710',
  message = 'Hello Seikural Innovation, I would like to know more about your services.',
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Smoothly enter into view shortly after mount / initial page load
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const cleanNumber = phoneNumber.replace(/[^0-9]/g, '');
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = cleanNumber
    ? `https://wa.me/${cleanNumber}?text=${encodedMessage}`
    : `https://wa.me/?text=${encodedMessage}`;

  return (
    <aside
      aria-label="WhatsApp Contact"
      className="position-fixed bottom-0 end-0 m-3 m-md-4"
      style={{
        zIndex: 1050,
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(28px) scale(0.75)',
        transition: 'opacity 0.75s cubic-bezier(0.16, 1, 0.3, 1), transform 0.75s cubic-bezier(0.16, 1, 0.3, 1)',
        pointerEvents: isVisible ? 'auto' : 'none',
      }}
    >
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        title="Chat with us on WhatsApp"
        className="d-flex align-items-center justify-content-center text-decoration-none position-relative tw-transition-transform tw-duration-300 hover:tw-scale-110 active:tw-scale-95"
        style={{ width: '62px', height: '62px' }}
      >
        {/* Continuous breathing glow aura (ambient green glow matching reference image) */}
        <span
          className="position-absolute rounded-circle tw-bg-emerald-400/35 sipl-whatsapp-glow-aura"
          style={{ width: '64px', height: '64px', filter: 'blur(6px)' }}
          aria-hidden="true"
        />

        {/* Continuous radiating ripple wave around the icon by default */}
        <span
          className="position-absolute rounded-circle tw-bg-emerald-500/25 tw-border tw-border-emerald-400/40 sipl-whatsapp-ripple-ring"
          style={{ width: '50px', height: '50px' }}
          aria-hidden="true"
        />

        {/* Circular WhatsApp Button Body */}
        <span
          className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden tw-bg-[#25D366] tw-shadow-lg tw-shadow-emerald-500/40 position-relative"
          style={{ width: '48px', height: '48px' }}
        >
          {img.whatsappIcon ? (
            <img
              src={img.whatsappIcon}
              alt="WhatsApp"
              decoding="async"
              className="rounded-circle"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transform: 'scale(1.08)',
              }}
            />
          ) : (
            <svg
              viewBox="0 0 24 24"
              width="27"
              height="27"
              fill="currentColor"
              className="tw-text-white"
              aria-hidden="true"
            >
              <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.711 2.598 2.664-.699c.971.53 1.838.814 2.8.814 3.18 0 5.768-2.587 5.768-5.766 0-3.18-2.588-5.766-5.772-5.766zm0 10.367c-.886 0-1.72-.25-2.451-.703l-.176-.109-1.821.478.486-1.776-.115-.183c-.488-.775-.746-1.636-.745-2.509 0-2.536 2.063-4.598 4.601-4.598 2.538 0 4.6 2.062 4.6 4.598 0 2.537-2.062 4.599-4.599 4.599z" />
            </svg>
          )}
        </span>
      </a>
    </aside>
  );
};

export default WhatsAppButton;
